import React from "react";

const DeliveryAvailable = () => {
  return (
    <div
      className="pt-10 w-[100%] mx-auto mb-10 md:mb-32"
      id="deliveryAvailable"
    >
      <h2 className="mb-4">配送対象国・地域について</h2>
      <div className="bg-[#ffffff] max-w-[1300px] mx-auto mt-4 md:mt-0 mb-5 md:mb-10 py-10 md:py-20 font-bold">
        <div className="bg-[#F6C544] w-[80%] md:w-[450px] mx-auto mb-2 md:mb-4 py-2 md:py-4 text-[#ffffff] text-[16px] md:text-[30px] rounded-[4px] md:rounded-[8px]">
          <h3>一般商品の配送対象国</h3>
        </div>
        <div className="w-[90%] md:w-full max-w-[1100px] mx-auto text-[13px] md:text-[24px] border-4 md:border-8 border-[#F6C544] py-4 md:py-10 px-6 md:px-12 rounded-[4px] md:rounded-[16px] mb-4 md:mb-12">
          <p>
            中国・韓国・台湾・香港・シンガポール・タイ・オーストラリア
            <br />
            英国・米国・フランス・マレーシア・インドネシア・フィリピン
            <br />
            ベトナム・カナダ・ドイツ・イタリア・スペイン・オランダ
            <br />
            オーストラリア・スイス
          </p>
        </div>

        <div className="bg-[#F6C544] w-[80%] md:w-[450px] mx-auto mb-2 md:mb-4 py-2 md:py-4 text-[#ffffff] text-[16px] md:text-[30px] font-bold rounded-[4px] md:rounded-[8px]">
          <h3>アルコールの配送対象国</h3>
        </div>
        <div className="w-[90%] md:w-full max-w-[1100px] mx-auto text-[13px] md:text-[24px] border-4 md:border-8 border-[#F6C544] py-6 md:py-10 px-6 md:px-12 rounded-[4px] md:rounded-[16px]">
          <p>
            中国・スイス・韓国・台湾・香港・シンガポール・タイ・オーストラリア
            <br />
            英国・スペイン
          </p>
        </div>
      </div>
    </div>
  );
};

export default DeliveryAvailable;
